import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

createApp(App)
    .use(router)
    .mount('#app')
// src/main.js

// Kakao 초기화
window.Kakao && !window.Kakao.isInitialized() && window.Kakao.init("f4ce4d051903b1cfc9f3e59ac8046c0b");
console.log("✅ Kakao SDK Initialized");